

























































import { GeekFullName } from '@/components';
import { GeekItemForLeaderboard, WindowBreakpoint } from '@/models';
import { typedStore } from '@/store';
import { getWindowWidth } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'LeaderboardList',
  components: {
    GeekFullName: () => Promise.resolve(GeekFullName),
  },
  props: {
    geeks: Array as () => GeekItemForLeaderboard[],
    activeGeek: Object as () => GeekItemForLeaderboard,
  },
  computed: {
    areMoreItemsAvailable(): boolean {
      return this.geeks.length < typedStore(this).state.scores.pagination.totalCount && this.geeks.length > 0;
    },
  },
  directives: {
    scrollToProfile: {
      bind: (el) => {
        el.addEventListener('click', () => {
          if (getWindowWidth() < WindowBreakpoint.Medium) {
            document.querySelector('.profile-container')!.scrollIntoView({behavior: 'smooth'});
          }
        });
      },
    },
  },
  methods: {
    loadMoreElements() {
      this.$emit('loadMore');
    },
    getGeekTooltip(geek: GeekItemForLeaderboard): string {
      return geek.isActive ? '' : this.$t('leaderboard.inactive-geek-tooltip') as string;
    },
    getGeekLeaderboardPosition(geek: GeekItemForLeaderboard): string {
      switch (geek.leaderboardPosition) {
        case 1:
          return 'first';
        case 2:
          return 'second';
        case 3:
          return 'third';
        default:
          return '';
      }
    },
    setActiveGeek(geek: GeekItemForLeaderboard) {
      this.$emit('setActiveGeek', geek);
    },
  },
});
